import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { SortOptionsForType } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

import { OrderKeys } from '../../../spacesPlatform/models/OrderKeys';

export const WorkbookSubspaceDatasourcesSortOptions: SortOptionsForType = {
  defaultOrder: [Order.asc(OrderKeys.name)],
  options: {
    'name': SortOptions.name,
    'refresh': SortOptions.datasourceRefresh,
    'alert': SortOptions.alert
  },
  displaySortDropdown: true
};

export const WorkbookSubspaceViewsSortOptions: SortOptionsForType = {
  defaultOrder: [Order.asc(OrderKeys.index), Order.asc(OrderKeys.name)],
  options: {
    'name': SortOptions.name,
    'hits': SortOptions.hits,
    'sheet': SortOptions.sheetIndex,
  },
  displaySortDropdown: true
};
